import TeamGrade from "components/UI/grade/teamGrade/TeamGrade";
import { useFetching } from "components/hooks/useFetching";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import RatingJuryService from "services/JuryService";
import OccasionService from "services/OccasionService";
import Strings from "values/Strings";

const STORAGE_KEYS = {
    RESULT_LIST: 'teamGrade_resultList',
    OCCASIONS: 'teamGrade_occasions',
    OCCASION_LIST: 'teamGrade_occasionList',
    CURRENT_OCCASION_ID: 'teamGrade_currentOccasionId'
};

function TeamGradePage() {
    const [resultList, setResultList] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEYS.RESULT_LIST);
            return saved ? JSON.parse(saved) : {};
        } catch (error) {
            return {};
        }
    });
    const [occasions, setOccasions] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEYS.OCCASIONS);
            return saved ? JSON.parse(saved) : [];
        } catch (error) {
            return [];
        }
    })
    const [occasionList, setOccasionList] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEYS.OCCASION_LIST);
            return saved ? JSON.parse(saved) : [];
        } catch (error) {
            return [];
        }
    })
    const [currentOccasionId, setCurrentOccasionId] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEYS.CURRENT_OCCASION_ID);
            return saved ? JSON.parse(saved) : null;
        } catch (error) {
            return null;
        }
    })


    function replaceNullWithZero(obj) {
        for (let key in obj) {
            if (obj[key] === null) {
                obj[key] = 0;
            } else if (typeof obj[key] === 'object') {
                replaceNullWithZero(obj[key]);
            }
        }
    }

    const notificationError = (error) => {
        if (error.length > 0) {
            NotificationManager.error(JSON.stringify(error), Strings.notificationsErrorTitle, 5000);
        }
    }

    const [fetchingOccasion, loadingFetchingOccasion, errorFetchingOccasion] = useFetching(async () => {
        try {
            const res = await OccasionService.getOccasions()
            setOccasions(res)
            setOccasionList(res.map(item => item.name))
            localStorage.setItem(STORAGE_KEYS.OCCASIONS, JSON.stringify(res))
            localStorage.setItem(STORAGE_KEYS.OCCASION_LIST, JSON.stringify(res.map(item => item.name)))
        } catch (error) {
            notificationError(error)
        }
    })

    const [fetchingRatings, loadingFetchingRatings, errorFetchingRatings] = useFetching(async (id) => {
        try {
            const res = await RatingJuryService.getFinnalRatings(id)
            replaceNullWithZero(res)
            setResultList(res)
            localStorage.setItem(STORAGE_KEYS.RESULT_LIST, JSON.stringify(res))
        } catch (error) {
            notificationError(error)
        }
    })

    const [fetchingRatingsFast, loadingFetchingRatingsFast, errorFetchingRatingsFast] = useFetching(async (id) => {
        try {
            const res = await RatingJuryService.getFinnalRatingsFast(id)
            replaceNullWithZero(res)
            // Сохраняем существующие image_command из текущего resultList
            const currentResultList = resultList
            if (currentResultList?.finalGrade && Array.isArray(res?.finalGrade)) {
                res.finalGrade = res.finalGrade.map((newItem, idx) => {
                    const currentItem = currentResultList.finalGrade?.find(item => item.command_id === newItem.command_id)
                    return {
                        ...newItem,
                        image_command: currentItem?.image_command || newItem.image_command
                    }
                })
            }
            setResultList(res)
            localStorage.setItem(STORAGE_KEYS.RESULT_LIST, JSON.stringify(res))
        } catch (error) {
            notificationError(error)
        }
    })


    const [updateRatings, loadingUpdateRatings, errorUpdateRatings] = useFetching(async ({ data, category }) => {
        try {
            // ищем из массива тот элемент в котором есть нужная нам категория
            data = data.find(item => Object.keys(item)[0] === category)
            // получаем ту категорию, в которой были изменения
            const categoryArray = data[category]
            await RatingJuryService.updateRatingJuryPosition(categoryArray)
            NotificationManager.success(Strings.notificationsDataUpdate, Strings.notificationsSuccessTitle, 2500);
        } catch (error) {
            notificationError(error)
        }
    })

    useEffect(() => {
        fetchingOccasion()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (currentOccasionId && occasions.length > 0) {
            fetchingRatings(currentOccasionId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentOccasionId, occasions.length]);

    const handleCurrentOccasionChange = (occasionId) => {
        setCurrentOccasionId(occasionId)
        localStorage.setItem(STORAGE_KEYS.CURRENT_OCCASION_ID, JSON.stringify(occasionId))
    }

    const handleRefreshRatings = () => {
        if (currentOccasionId) {
            fetchingRatings(currentOccasionId)
        }
    }

    const handleRefreshRatingsFast = () => {
        if (currentOccasionId) {
            fetchingRatingsFast(currentOccasionId)
        }
    }


    return (
        <TeamGrade
            fetchingRatings={fetchingRatings}
            occasions={occasions}
            occasionList={occasionList}
            resultList={resultList}
            updateRatings={updateRatings}
            notificationError={notificationError}
            currentOccasionId={currentOccasionId}
            onCurrentOccasionChange={handleCurrentOccasionChange}
            onRefreshRatings={handleRefreshRatings}
            onRefreshRatingsFast={handleRefreshRatingsFast}
            loadingFetchingRatings={loadingFetchingRatings}
            loadingFetchingRatingsFast={loadingFetchingRatingsFast}
        />
    );
}

export default TeamGradePage;